import config from '../config';
import { authFetch } from '../auth/AuthContext';

/**
 * Calls an authenticated JSON endpoint, transparently refreshing the access
 * token and retrying once if it has expired. Pass `getToken`/`refresh` from
 * `useAuth()`.
 */
export async function authedJson<T>(
  path: string,
  options: RequestInit,
  getToken: () => string | null,
  doRefresh: () => Promise<boolean>,
): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');

  const res = await authFetch(`${config.apiUrl}${path}`, { ...options, headers }, getToken, doRefresh);
  if (res.status === 204) return undefined as T;

  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message ?? 'Request failed');
  return data as T;
}
